import axios from "@/libs/api.request.js";

// --------------  签到活动 ---------------

// 活动首页信息
export const getSignInHome = (data) => {
  return axios.request({
    url: `/platform-box-game/wechat/sign/homeList`,
    data,
    method: "post",
    requireToken: true
  });
};

// 签到
export const signInActionApi = (data) => {
  return axios.request({
    url: `/platform-box-game/wechat/sign/signIn`,
    data,
    method: "post",
    requireToken: true
  });
};

// 领取签到礼包
export const signInReceive = (data) => {
  return axios.request({
    url: `/platform-box-game/wechat/sign/drawSignGift`,
    data,
    method: "post",
    requireToken: true
  });
};

// --------------  礼包中心 ---------------
// 礼包列表
export const getGiftListApi = (data) => {
  return axios.request({
    url: `/platform-box-game/wechat/gift/list`,
    data,
    method: "post",
    requireToken: true
  });
};
// 领取礼包
export const receiveGiftApi = (data) => {
  return axios.request({
    url: `/platform-box-game/wechat/gift/receive`,
    data,
    method: "post",
    requireToken: true,
    judgeCode: true,
  });
};
// 我的礼包
export const getMyGiftListApi = (data) => {
  return axios.request({
    url: `/platform-box-game/wechat/gift/mine/list`,
    data,
    method: "post",
    requireToken: true
  });
};

// 游戏中心 - 游戏列表
export const getGameListApi = (data) => {
  return axios.request({
    url: `/platform-box-game/wechat/gameCenter/list`,
    data,
    method: "post",
    requireToken: true
  });
};
// 游戏中心 - 活动信息
export const getGameInfoApi = (data) => {
  return axios.request({
    url: `/platform-box-game/wechat/gameCenter/config`,
    data,
    method: "post",
    requireToken: true
  });
};

// 累充活动 - 首页
export const getPayAmountInfo = (data) => {
  return axios.request({
    url: `/platform-box-game/wechat/PayActivity/payActivityHomeList`,
    data,
    method: "post",
    requireToken: true
  });
};
// 累充活动 - 领取礼包
export const receivePayAmountGift = (data) => {
  return axios.request({
    url: `/platform-box-game/wechat/PayActivity/payActivityDrawGift`,
    data,
    method: "post",
    requireToken: true,
    judgeCode: true,
  });
};
